export function hslToHex(h: number, s: number, l: number): string {
  function toHex(n: number): string {
    const alpha = s * Math.min(l, 1 - l)

    return Math.round(255 * (l - alpha * Math.max(-1, Math.min(((n + h / 30) % 12) - 3, 9 - ((n + h / 30) % 12), 1))))
      .toString(16)
      .padStart(2, '0')
  }

  return `#${toHex(0)}${toHex(8)}${toHex(4)}`
}
